import { Box, Button, InputAdornment, Stack, TextField } from '@mui/material';
import { ArrowDropDown as DownIcon, ArrowDropUp as UpIcon } from '@mui/icons-material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { ButtonLabel, FilterButton, FiltersCount } from '../FilterAndSearchPanel/styles';
import { abyssColors } from '@/theme/colors';

type Props = {
  displayFilters: boolean;
  filtersCount: number;
  showResetButton?: boolean;
  rightComponent: React.ReactNode;
  handleResetFilters: () => void;
  handleDisplayFilters: () => void;
  handleSearch?: (value: string) => void;
};

const FiltersHeader = ({
  displayFilters,
  filtersCount,
  showResetButton,
  rightComponent,
  handleDisplayFilters,
  handleResetFilters,
  handleSearch,
}: Props) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {
    handleSearch?.(searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const FiltersButton = (
    <FilterButton onClick={handleDisplayFilters} data-testid="filters-button">
      <ButtonLabel>Filters</ButtonLabel>
      <FiltersCount>{filtersCount}</FiltersCount>
      {displayFilters ? <UpIcon /> : <DownIcon />}
    </FilterButton>
  );

  const ResetButton = (
    <Button
      sx={{ ml: 1.5, height: 32, backgroundColor: abyssColors.primary[500] }}
      variant="contained"
      disabled={!filtersCount}
      onClick={handleResetFilters}
    >
      Reset
    </Button>
  );

  const actionButtons = (
    <Box>
      {FiltersButton}
      {showResetButton && ResetButton}
    </Box>
  );

  return (
    <Stack
      spacing={1}
      alignItems="center"
      direction={{ sm: 'column', md: 'row' }}
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {actionButtons}
        {handleSearch && (
          <TextField
            sx={{
              width: '73.2rem',
              '& input': {
                fontSize: '1.4rem',
              },
            }}
            size="small"
            placeholder="Search"
            data-testid="search-field"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchTerm && (
                    <ClearIcon sx={{ cursor: 'pointer' }} onClick={() => setSearchTerm('')} />
                  )}
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              sx: { height: 32, pl: 1 },
            }}
          />
        )}
      </Stack>
      {rightComponent}
    </Stack>
  );
};

export default FiltersHeader;
